<template>
  <div
    v-if="sidebarStore.breadcrumbs.length > 0"
    class="d-flex justify-space-between align-center mb-7 mt-7"
  >
    <!-- 왼쪽: 페이지 타이틀 -->
    <h2 class="text-h2 font-weight-bold mb-0">
      {{ sidebarStore.breadcrumbs[sidebarStore.breadcrumbs.length - 1].title }}
    </h2>

    <!-- 오른쪽: Breadcrumb -->
    <v-breadcrumbs
      :items="sidebarStore.breadcrumbs"
      class="pa-0 text-medium-emphasis text-subtitle-6"
    >
      <template #divider>
        <v-icon size="18">mdi-chevron-right</v-icon>
      </template>
      <template #title="{ item }">
        <span class="text-subtitle-6 font-weight-medium">{{ item.title }}</span>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script setup lang="ts">
import { userSidebarStore } from "@/common/stores/SidebarStore.ts";
const sidebarStore = userSidebarStore();
</script>
